import * as React from 'react'
function SvgFolder(props) {
	return (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 40 40"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<g fill="currentColor" fillRule="evenodd">
				<path d="M34 18H6c-1.2 0-2 .8-2 2v14c0 1.2.8 2 2 2h28c1.2 0 2-.8 2-2V20c0-1.2-.8-2-2-2zM32 8H18.8l-3.4-3.4C15 4.2 14.6 4 14 4H8c-1.2 0-2 .8-2 2v8h28v-4c0-1.2-.8-2-2-2z" />
			</g>
		</svg>
	)
}
export default SvgFolder
